import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getEventCategory, createEventCategory, updateEventCategory,deleteEventCategory } from '../../../Utils/apiServices';
import Modal from '../../../Components/Modal';
import Button from '../../../Components/Button';
import Snackbar from '../../../Components/Snackbar';
import ConfirmDialog from '../../../Components/ConfirmDialog';

const Category = () => {
    const [category, setCategory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newCategory, setNewCategory] = useState('');
    const [youtubeLink, setYoutubeLink] = useState('');
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [eventType, setEventType] = useState('');
    const [description, setDescription] = useState('');
    const [withAnalytics, setWithAnalytics] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const videoUrl = location.state?.videoUrl;
    const [deleteCategoryId, setDeleteCategoryId] = useState(null);
    const [deleteCategoryDialogOpen, setDeleteCategoryDialogOpen] = useState(false);
    const [deleteCategoryLoading, setDeleteCategoryLoading] = useState(false);

    const fetchCategory = async () => {
        try {
            const response = await getEventCategory(id);
            console.log(response);
            setCategory(response.data);
        } catch (error) {
            console.error('Error fetching category:', error);
        }
    };

    useEffect(() => {
        // Prevent screen recording
        const preventRecording = () => {
            if (navigator.mediaDevices) {
                navigator.mediaDevices.getDisplayMedia = async () => {
                    throw new Error('Screen recording is not allowed');
                };
            }
            
            // Prevent screen capture
            document.addEventListener('keydown', (e) => {
                if (
                    (e.ctrlKey || e.metaKey) && 
                    (e.shiftKey) && 
                    (e.key === 'I' || e.key === 'i' || e.key === 'P' || e.key === 'p')
                ) {
                    e.preventDefault();
                }
            });
        };

        preventRecording();

        if (id) {
            fetchCategory();
        }

        // Disable right-click
        document.addEventListener('contextmenu', (e) => e.preventDefault());
        
        // Clean up
        return () => {
            document.removeEventListener('contextmenu', (e) => e.preventDefault());
            document.removeEventListener('keydown', () => {});
        };
    }, [id]);

    const handleSubmit = async () => {
        try {
            if (isEditing) {
                const updatePayload = {
                    id: selectedCategory.id,
                    category: newCategory,
                    event_id: parseInt(id), // Ensure event_id is a number
                    video_url: youtubeLink,
                    event_type: eventType,
                    description: description,
                    with_analystics: withAnalytics
                };
                
                console.log('Updating with data:', updatePayload);
                
                const response = await updateEventCategory(updatePayload);

                console.log('Update response:', response);
                
                if (response.status === 200) {
                    setIsModalOpen(false);
                    setNewCategory('');
                    setYoutubeLink('');
                    setEventType('');
                    setWithAnalytics(false);
                    setIsEditing(false);
                    setSelectedCategory(null);
                    setShowSnackbar(true);
                    await fetchCategory();
                    setTimeout(() => {
                        setShowSnackbar(false);
                    }, 3000);
                }
            } else {
                const response = await createEventCategory({
                    category: newCategory,
                    event_id: id,
                    video_url: youtubeLink,
                    event_type: eventType,
                    description: description,
                    with_analystics: withAnalytics
                });
                console.log(response);
                if (response.status === 200) {
                    setIsModalOpen(false);
                    setNewCategory('');
                    setYoutubeLink('');
                    setEventType('');
                    setDescription('');
                    setWithAnalytics(false);
                    setShowSnackbar(true);
                    navigate(`/clubs/category/${id}`); // Adjust this path to your list view route
                    setTimeout(() => {
                        setShowSnackbar(false);
                    }, 3000);
                }
            }
        } catch (error) {
            console.error('Error handling category:', error);
        }
    };

    const handleEdit = (item) => {
        setSelectedCategory(item);
        setNewCategory(item.category);
        setYoutubeLink(item.video_url || '');
        setEventType(item.event_type || '');
        setDescription(item.description || '');
        setWithAnalytics(!!item.with_analystics);
        setIsEditing(true);
        setIsModalOpen(true);
    };

    const openDeleteCategoryConfirm = (categoryId, e) => {
        e.stopPropagation();
        setDeleteCategoryId(categoryId);
        setDeleteCategoryDialogOpen(true);
    };

    const closeDeleteCategoryConfirm = () => {
        if (deleteCategoryLoading) return;
        setDeleteCategoryDialogOpen(false);
        setDeleteCategoryId(null);
    };

    const confirmDeleteCategory = async () => {
        if (deleteCategoryId == null) return;
        setDeleteCategoryLoading(true);
        try {
            const response = await deleteEventCategory({ id: deleteCategoryId });
            if (response.status === 200) {
                setShowSnackbar(true);
                setDeleteCategoryDialogOpen(false);
                setDeleteCategoryId(null);
                await fetchCategory();
                setTimeout(() => {
                    setShowSnackbar(false);
                }, 3000);
            }
        } catch (error) {
            console.error('Error deleting category:', error);
        } finally {
            setDeleteCategoryLoading(false);
        }
    };

    return (
        <div style={{ 
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            padding: '24px'
        }}>
            <ConfirmDialog
                open={deleteCategoryDialogOpen}
                title="Delete category"
                message="Are you sure you want to delete this category? This action cannot be undone."
                confirmLabel="Delete"
                onCancel={closeDeleteCategoryConfirm}
                onConfirm={confirmDeleteCategory}
                loading={deleteCategoryLoading}
            />
            {videoUrl && (
                <div style={{ 
                    marginTop: '2rem',
                    marginBottom: '2rem',
                    marginLeft: '2rem',
                    marginRight: '2rem',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    backgroundColor: '#000'
                }}>
                    <video
                        autoPlay
                        loop
                        muted
                        style={{
                            width: '100%',
                            maxHeight: '600px',
                            objectFit: 'cover',
                            backgroundColor: '#000',
                            display: 'block'
                        }}
                    >
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            )}
            
            <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <h1 style={{ fontSize: '2.5rem', margin: 0 }}>Category</h1>
                    <Button
                        onClick={() => {
                            setIsEditing(false);
                            setSelectedCategory(null);
                            setNewCategory('');
                            setYoutubeLink('');
                            setEventType('');
                            setDescription('');
                            setWithAnalytics(false);
                            setIsModalOpen(true);
                        }}
                        startIcon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                        }
                    >
                        Add Category
                    </Button>
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setIsEditing(false);
                    setSelectedCategory(null);
                    setNewCategory('');
                    setYoutubeLink('');
                    setEventType('');
                    setDescription('');
                    setWithAnalytics(false);
                }}
                title={isEditing ? "Edit Category" : "Add New Category"}
                actions={
                    <>
                        <Button 
                            variant="secondary" 
                            onClick={() => {
                                setIsModalOpen(false);
                                setIsEditing(false);
                                setSelectedCategory(null);
                                setNewCategory('');
                                setYoutubeLink('');
                                setEventType('');
                                setDescription('');
                                setWithAnalytics(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                    </>
                }
            >
                <input
                    type="text"
                    value={newCategory}
                    onChange={(e) => setNewCategory(e.target.value)}
                    placeholder="Enter category"
                    style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                    }}
                />
                <input
                    type="text"
                    value={youtubeLink}
                    label="Youtube Video Link"
                    onChange={(e) => setYoutubeLink(e.target.value)}
                    placeholder="Enter Youtube Video Link"
                    fullWidth
                    style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                    }}
                />
                <select
                    value={eventType}
                    onChange={(e) => setEventType(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem',
                        marginTop: '12px'
                    }}
                >
                    <option value="">Select Event Type</option>
                    <option value="Dressage">Dressage</option>
                    <option value="Jumping">Jumping</option>
                </select>
                <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter description"
                    style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem',
                        minHeight: '100px',
                        marginTop: '12px',
                        resize: 'vertical'
                    }}
                />
                <label
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '12px',
                        fontSize: '1rem',
                        color: '#333'
                    }}
                >
                    <input
                        type="checkbox"
                        checked={withAnalytics}
                        onChange={(e) => setWithAnalytics(e.target.checked)}
                        style={{ width: '18px', height: '18px' }}
                    />
                    With Analytics
                </label>
            </Modal>

            <Snackbar
                message={isEditing ? "Category updated successfully!" : "Category created successfully!"}
                isOpen={showSnackbar}
                type="success"
            />

            {category?.success && Array.isArray(category.data) && (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '20px',
                    padding: '20px 0'
                }}>
                    {category.data.map((item) => (
                        <div 
                            key={item.id}
                            onClick={() => navigate(`/clubs/results/${item.id}`, {
                                state: { withAnalytics: !!item.with_analystics }
                            })}
                            style={{
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px',
                                padding: '24px',
                                backgroundColor: 'white',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                cursor: 'pointer',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
                                }
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3 style={{ 
                                    fontSize: '1.4rem', 
                                    fontWeight: '600',
                                    marginBottom: '16px',
                                    color: '#2c3e50'
                                }}>
                                    {item.category}
                                </h3>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        variant="secondary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleEdit(item);
                                        }}
                                        startIcon={
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                            </svg>
                                        }
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={(e) => openDeleteCategoryConfirm(item.id, e)}
                                        startIcon={
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M3 6h18"></path>
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
                                                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                            </svg>
                                        }
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                color: '#666',
                                marginBottom: '12px'
                            }}>
                                <span style={{
                                    backgroundColor: '#f0f2f5',
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '0.9rem'
                                }}>
                                    Event ID: {item.event_id}
                                </span>
                            </div>
                            <div style={{
                                backgroundColor: '#e8f5e9',
                                color: '#2e7d32',
                                padding: '6px 12px',
                                borderRadius: '20px',
                                fontSize: '0.9rem',
                                display: 'inline-block',
                                fontWeight: '500'
                            }}>
                                {item.event_type || 'No Event Type'}
                            </div>
                            {item.description && (
                                <div style={{
                                    marginTop: '12px',
                                    color: '#666',
                                    fontSize: '0.9rem',
                                    lineHeight: '1.5'
                                }}>
                                    {item.description}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Category;